import { collections } from "@/mocks/chigua";

export default function Collections() {
  return (
    <section id="collections" className="border-y border-background-200 bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-600">
              <i className="ri-folder-open-fill"></i> 一站式归档 · 合集导航
            </span>
            <h2 className="mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">专题合集：想回看随时进</h2>
            <p className="mt-2 text-sm text-foreground-600">把散落的热讯按主题归档成合集，追更之外也有地方慢慢补课。</p>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-5">
          {collections.map((col) => (
            <div
              key={col.id}
              className="group grid grid-cols-1 items-stretch overflow-hidden rounded-lg bg-background-50 border border-background-200 transition-colors hover:border-primary-300 md:grid-cols-[0.9fr_1.1fr]"
            >
              <div className="relative h-56 overflow-hidden md:h-auto md:min-h-[220px]">
                <img
                  src={col.img}
                  alt={col.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-col p-6 md:p-7">
                <div className="flex items-center justify-between gap-3">
                  <span className="rounded-md bg-accent-500 px-2.5 py-1 text-xs font-medium text-background-50 whitespace-nowrap">
                    专题合集
                  </span>
                  <span className="flex items-center gap-1 text-sm text-foreground-600 whitespace-nowrap">
                    <i className="ri-archive-fill text-primary-500"></i>
                    收录 {col.count} 条
                  </span>
                </div>
                <h3 className="mt-4 text-xl font-bold text-foreground-950 md:text-2xl">
                  <a href="#latest" className="hover:text-primary-600">
                    {col.title}
                  </a>
                </h3>
                <span className="mt-1 text-sm text-primary-600">{col.sub}</span>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{col.desc}</p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {col.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900 whitespace-nowrap"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <a
                  href="#latest"
                  className="mt-auto inline-flex w-fit items-center gap-1.5 pt-5 text-sm font-medium text-primary-600 whitespace-nowrap"
                >
                  进入合集 <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}